// Main Router Page for all the main Pages

import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router";
// import Builder from "./Builder";
import Liveview from "./Liveview";
import { LayoutSplashScreen } from "../../../infofleet";
import Support from "./Support";
import AuthCheck from "../../component/AuthCheck"; // AuthCheck is used to check if user has access for particular page or not by functional tree ids
import { fleet_parentId, homeId, manageaccountaccordId, managesettingsId, mrp_parentId, panelsearchId } from "./constant";

const Dashboardpage = lazy(() => import("./dashboard/DashboardView"));
const Reportpage = lazy(() => import("./report/ReportView"));
const PanelSearch = lazy(() => import("./panelsearch/PanelView"));
const ManageAccount = lazy(() => import("./manageaccount/ManageAccountView"));
const GeofencePage = lazy(() => import("./geofence/GeofenceView"));
const ManageSettings = lazy(() => import("./managesettings/SettingsView"));
const Fleetpage = lazy(() => import("./fleet/FleetView"));
const MRPpage = lazy(() => import("./mrp/MrpView"));
const UnAuthorized = lazy(() => import("../errors/UnAuthorized"));
export default function HomePage() {
  const url = window.location.href;
  const lastSegment = url.split("/").pop();

  if (lastSegment !== "Liveview") {
    const clearinterval_id_LiveView = localStorage.getItem("LiveView_interval");
    clearInterval(clearinterval_id_LiveView);
    localStorage.removeItem("LiveView_interval");
  }
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        {
          /* Redirect from root URL to /Liveview. */
          <Route path="/" element={<Navigate to="/Liveview" replace />} />
        }
        <Route path="/Liveview/*" element={<Liveview />} />
        <Route path="/report/*" element={<Reportpage />} />
        <Route path="/geofence/*" element={<GeofencePage />} />
        <Route path="/dashboard/*" element={<Dashboardpage />} />
        <Route path="/Support/*" element={<Support />} />
        <Route
          path="/panelsearch/*"
          element={
            AuthCheck(homeId, panelsearchId) ? <PanelSearch /> : <UnAuthorized />
          }
        />
        <Route
          path="/fleet/*"
          element={
            AuthCheck(fleet_parentId) ? <Fleetpage /> : <UnAuthorized />
          }
        />
        <Route
          path="/manageaccount/*"
          element={
            AuthCheck(homeId, manageaccountaccordId) ? (
              <ManageAccount />
            ) : (
              <UnAuthorized />
            )
          }
        />
        <Route
          path="/managesettings/*"
          element={
            AuthCheck(homeId, managesettingsId) ? (
              <ManageSettings />
            ) : (
              <UnAuthorized />
            )
          }
        />
        <Route
          path="/mrp/*"
          element={
            AuthCheck(mrp_parentId) ? <MRPpage /> : <UnAuthorized />
          }
        />

        {/* Catch-all fallback */}
        <Route path="*" element={<Navigate to="/error/error-v6" replace />} />
      </Routes>
    </Suspense>
  );
}



